export default "__VITE_ASSET__FMNIY8Kt__"